import RfqsStore from '#/unified-rfqs/store/rfqs';
import { isActiveRfq, Rfq } from '#/unified-rfqs/entities/rfq';
import { AuctionType } from '#/unified-rfqs/entities/shared';
import { ListRfqsReq } from '#/unified-rfqs/repositories/grfq-types';
import { GrfqService } from '#/unified-rfqs/services/grfq';
import { MergedSourcesFetcher } from '#/unified-rfqs/services/merged-sources-fetcher';
import { DrfqService } from '#/unified-rfqs/services/drfq';
import PublicStore from '#/unified-rfqs/store/public-store';
import { Instrument } from '#/unified-rfqs/entities/drfq/instruments';
import {
  matchesRfqFilters,
  RfqFilters,
} from '#/unified-rfqs/services/rfq-filtering';

interface RfqsServiceDeps {
  rfqsStore: RfqsStore;
  drfqService: DrfqService;
  grfqService: GrfqService;
  filters: RfqFilters;
}

export default class UnifiedRfqsListService extends PublicStore<Rfq> {
  public fetcher: MergedSourcesFetcher<ListRfqsReq, Rfq>;
  private filters: RfqFilters;
  private drfqFutureInstruments: readonly Instrument[] = [];

  constructor(deps: RfqsServiceDeps) {
    super(deps.rfqsStore);
    this.filters = deps.filters;
    const fetchers = [];

    if (this.shouldAddFetcher('OB')) {
      fetchers.push(deps.grfqService.listGrfqs);
    }
    if (this.shouldAddFetcher('RFQ')) {
      fetchers.push(deps.drfqService.listActiveDrfqs);
    }

    this.fetcher = new MergedSourcesFetcher<ListRfqsReq, Rfq>({
      fetchers,
      store: deps.rfqsStore,
      pageSize: 50,
      filterFn: (rfq: Rfq) =>
        isActiveRfq(rfq) &&
        matchesRfqFilters(rfq, this.filters, this.drfqFutureInstruments),
    });
  }

  setDrfqFutureInstruments(drfqFutureInstruments: readonly Instrument[]) {
    this.drfqFutureInstruments = drfqFutureInstruments;
  }

  private shouldAddFetcher(type: AuctionType) {
    return (
      this.filters.auctionTypes.some((option) => option.value === type) ||
      this.filters.auctionTypes.length === 0
    );
  }
}
